import React from 'react';

export type FormShellContextValue = {
    /** a field announces which section owns it, so errors can be attributed */
    registerField: (path: string, sectionId: string) => void;
    unregisterField: (path: string) => void;
    /** invalid-field count per section id, refreshed on every failed submit */
    sectionErrors: Record<string, number>;
};

export const FormShellContext = React.createContext<FormShellContextValue | null>(null);

export const SectionContext = React.createContext<string | null>(null);

/** dotted path for a Form.Item `name`, used as the field↔section key */
export const pathKey = (name: any): string =>
    Array.isArray(name) ? name.join('.') : String(name ?? '');
